import { Col, Container, Row } from 'reactstrap';
import bannerLogo from '../../../assets/images/Logo..png';

import Button from '../../../components/Button';
import BannerKV from './banner/BannerKV';
import useIsMobile from './useIsMobile';
import { useNavigate } from 'react-router-dom';

const Banner = () => {
  const isMobile = useIsMobile(575);
  const navigate = useNavigate();
  return (
    <div className="banner-wrapper">
      <div className="section-gap-lg home-section">
        <Container>
          <Row className="banner-description">
            <Col lg="6" sm="12" className="left-content">
              <div className="text-wrapper">
                <h1>AI-Powered. Human-Approved. Legally Sound.</h1>
                <p className="banner-paragraph">
                  Harnessing the speed of AI with the oversight of seasoned legal minds, we turn
                  complexity into clarity—faster, smarter, and legally sound.
                </p>
                <div className="banner-button">
                  <Button label={'Explore'} onClick={() => navigate('/expertise')} />
                  <Button label={'Request Demo'} onClick={() => navigate('/contact-us')} />
                </div>
              </div>
            </Col>
            <Col lg="6" sm="12" className=""></Col>
          </Row>

          <Row className="banner-logo-row">
            <Col lg="6" sm="12">
              <div className="banner-logo-col">
                <img src={bannerLogo} alt="logo" />
                <img src={bannerLogo} alt="logo" />
                <img src={bannerLogo} alt="logo" />
              </div>
            </Col>
          </Row>
          <div className="banner-kv">
            <BannerKV />
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Banner;
